import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Spinner from '../Player/Spinner';
import ButtonChannels from './ButtonChannels';
import { Grid, Slider } from '@mui/material';
import { VolumeUpIcon, VolumeOffIcon } from '@heroicons/react/solid/';
import PlayButton from '../Player/PlayButton';
import { useRef } from 'react';
import { Link } from 'wouter';
import { debounce } from 'lodash';

function Radio() {
  const audioRef = useRef(null);
  const [audio, setAudio] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [id, setId] = useState(132);
  const [nameOfStation, setNameOfStation] = useState('Deep Tech');
  const [imgOfStation, setImgOfStation] = useState(
    'https://i.imgur.com/hNpCG9g.gif'
  );
  const [linkOfStation, setLinkOfStation] = useState(
    '/genres/minimal&deep-tech'
  );
  const [volume, setVolume] = useState(100);

  /* Cargar imagen y audio */
  useEffect(() => {
    axios
      .get(`https://101.ru/api/channel/getListServersChannel/${id}/channel`)
      .then((response) => {
        let urlStreamHttps;
        for (let i = 0; i < response.data.result.length; i++) {
          let url = response.data.result[i].urlStream;
          if (url.match(/^https:\/\//)) {
            urlStreamHttps = url;
            break;
          }
        }
        if (urlStreamHttps) {
          setAudio(urlStreamHttps);
        } else {
          console.log("No se encontró una URL con https");
        }
      })
      .then(setTimeout(() => setIsLoading(false), 2000))
      .catch(err => {
        console.log(err.message);
        setNameOfStation('Nothing');
        setIsLoading(true);
      });
  }, [id]);

  /* reproducir y pausar audio */
  const playSongHandler = () => {
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(!isPlaying);
    } else {
      audioRef.current.play();
      setIsPlaying(!isPlaying);
    }
  };

  /* Volumen Slide */
  // eslint-disable-next-line
  const debounceAdjustVolume = useCallback(
    debounce(volume => {
      audioRef.current.volume = volume / 100;
    }, 150),
    []
  );

  useEffect(() => {
    if (volume > 0 && volume < 100) {
      debounceAdjustVolume(volume);
    }
  }, [volume, debounceAdjustVolume]);

  return (
    <div className="flex h-24 justify-between bg-gradient-to-tl from-zinc-900 to-black px-3 md:p-2 md:px-5">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {/* Left */}
          <div className="flex items-center normal-case">
            <Link to={linkOfStation}>
              <img
                loading="lazy"
                decoding="async"
                className="md:inline-grid h-20 w-20 rounded-full cursor-pointer md:ml-10 ml-2"
                src={imgOfStation}
                alt={nameOfStation}
              />
            </Link>
            <div className="flex items-center justify-between max-w-xs px-2 md:px-5 text-white">
              {/* Play or Pause 🎵 */}
              <PlayButton
                playSongHandler={playSongHandler}
                isPlaying={isPlaying}
                isLoading={isLoading}
              />
              <div className="flex slide__color items-center ml-1">
                {volume > 0 ? (
                  <VolumeUpIcon className="radio__icon hover:text-[#FF1A1A] cursor-pointer h-7 mr-1 md:mr-2" />
                ) : (
                  <VolumeOffIcon className="radio__icon hover:text-[#FF1A1A] cursor-pointer h-7 mr-1 md:mr-2" />
                )}
                <Grid container spacing={1} className="m-auto">
                  <Grid item xs className="w-[60px] sm:w-[75px] md:w-[100px]">
                    <Slider
                      value={volume}
                      onChange={e => setVolume(Number(e.target.value))}
                      min={0}
                      max={100}
                      sx={{
                        height: 4,
                        color: '#fff',
                        '&:hover': {
                          color: '#FF1A1A',
                        },
                        '& .MuiSlider-thumb': {
                          color: '#fff',
                          width: 10,
                          height: 10,
                          transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
                          '&:before': {
                            boxShadow: '0 2px 12px 0 rgba(0,0,0,0.4)',
                          },
                          '&:hover, &.Mui-focusVisible': {
                            boxShadow: `0px 0px 0px 0px rgb(255 255 255 / 16%)`,
                          },
                          '&.Mui-active': {
                            width: 15,
                            height: 15,
                          },
                        },
                        '& .MuiSlider-rail': {
                          color: '#fff',
                          opacity: 0.25,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
          <ButtonChannels
            nameOfStation={nameOfStation}
            setNameOfStation={setNameOfStation}
            setImgOfStation={setImgOfStation}
            setLinkOfStation={setLinkOfStation}
            setId={setId}
          />

          <audio
            ref={audioRef}
            aria-hidden
            autoPlay={true}
            muted={volume === 0}
            src={audio}
          />
        </>
      )}
    </div>
  );
}

export default Radio;
